import { useEffect, useRef } from "react";
import { createBrowserHistory } from "history";
import AudioService from "services/audio.service";
import SocketService from "services/socket.service";
import AuthService from "services/auth.service";
import { useDispatch } from "react-redux";
import { fetchNotifications } from "app/notificationSlice";
import { fetchUnreads } from "app/teleconsultSlice";
import BookdocIcon from "assets/icons/BookdocIcon.svg";
import { Link } from "react-router-dom";

import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

export function NotificationSocket() {
  const dispatch = useDispatch();
  const isCancelledSocket = useRef(false);
  const currentUser = AuthService.getCurrentUser();
  const currentAssistant = AuthService.getCurrentAssistant();
  const practiceLocation = AuthService.getPracticeLocation();
  const socketInfo = AuthService.getSocketInfo();
  const mainSources = ['Appointment','ChatMessageNotification','ChatSession'];
  const assistantSources = ['Appointment','e-prescription']
  const doctorSources = ['teleconsult__new_chat_session','teleconsult__new_chat_message','e-prescription']
  const doctorChannel = '/notifications/doctor/';
  const clinicChannel = '/notifications/clinic/'; 

  /* remember to disconnect faye whenever logout */
  useEffect(() => {    
    var canNotify;
    var channel = socketInfo.isClinic && socketInfo.isAssistant ? clinicChannel : doctorChannel;
    var authToken = currentUser?.auth_token || currentAssistant?.auth_token

    if(channel){
      SocketService.setHeader(authToken, socketInfo);
      SocketService.subscribe(channel, socketInfo, function(data){
        var notificationData = JSON.parse(data);
        var source = notificationData.source
        var payload = notificationData.payload
        
        if(socketInfo.isAssistant){
          canNotify = notificationData.payload && assistantSources.includes(notificationData.source);
        }else{
          canNotify = notificationData.payload && (doctorSources.includes(notificationData.payload?.type) || mainSources.includes(notificationData.source));
        }
        
        // [NOTE] To notify user with notification sound
        if(canNotify){
          if(payload?.type === 'e-prescription' || source !== 'Appointment' || 
          (source === 'Appointment' && payload?.appointment_type === 'virtual') || 
          (source === 'Appointment' && payload?.appointment_type === 'physical' && payload?.location === practiceLocation?.name)){
            AudioService.notification();
            UpdateNotifications();
          }

          if (payload?.type === "e-prescription" && payload?.title) {
            toast(
              <CustomToast
                title={payload?.title}
                text={notificationData?.message}
              />,
              {
                autoClose: 300000,
                className: "notification-toast",
                hideProgressBar: true,
              }
            );
          }
        }

        // [NOTE] To update the teleconsult notification badge number
        if(!socketInfo.isAssistant && (doctorSources.includes(payload?.type) || mainSources.includes(source))){
          dispatch(fetchUnreads());
        }
      })
    }
    return () => {
      isCancelledSocket.current = true;
    };
  }, [currentUser]); // eslint-disable-line

  const CustomToast = ({ title, text }) => (
    <div className="toast-container">
      <Link to="/eb/prescriptions" className="stretched-link"></Link>
      <img src={BookdocIcon} alt="bookdoc-logo" />
      <div className="content">
        <p className="title">{title}</p>
        <p className="description">{text}</p>
      </div>
    </div>
  );

  const UpdateNotifications = () => {
    if(['/eb/notifications', '/notifications'].indexOf(createBrowserHistory().location.pathname) > -1){
      dispatch(fetchNotifications(1))
    }
  };

  return null;
}

export default NotificationSocket;